// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1vrCw","unreadBadge":"styles_unreadBadge__2E4rE","modalContent":"styles_modalContent__1e6Nf","modal":"styles_modal__1oMYZ"};